import { render, staticRenderFns } from "./LetterContent.vue?vue&type=template&id=a306bca2&scoped=true&"
import script from "./LetterContent.vue?vue&type=script&lang=js&"
export * from "./LetterContent.vue?vue&type=script&lang=js&"
import style0 from "./LetterContent.vue?vue&type=style&index=0&id=a306bca2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a306bca2",
  null
  
)

export default component.exports